import { render, staticRenderFns } from "./PzInputCoin.vue?vue&type=template&id=6036018a&"
import script from "./PzInputCoin.vue?vue&type=script&lang=js&"
export * from "./PzInputCoin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\xampp\\htdocs\\simulador_new\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6036018a')) {
      api.createRecord('6036018a', component.options)
    } else {
      api.reload('6036018a', component.options)
    }
    module.hot.accept("./PzInputCoin.vue?vue&type=template&id=6036018a&", function () {
      api.rerender('6036018a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/commons/forms/Fields/PzInputCoin.vue"
export default component.exports